export default function loadInvoca(){
    (function(i,n,v,o,c,a) { i.InvocaTagId = o; var s = n.createElement('script'); s.type = 'text/javascript';
    s.async = true; s.src = ('https:' === n.location.protocol ? 'https://' : 'http://' ) + v;
    var fs = n.getElementsByTagName('script')[0]; fs.parentNode.insertBefore(s, fs);
  })(window, document, 'solutions.invocacdn.com/js/invoca-latest.min.js', '2013/1325511193');

}